"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessSettingsMenuSelector = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ShareSettingsOptionSection_1 = require("Common/ShareSettings/ShareSettingsOptionSection");
var GetSubtextForSettings_1 = require("./GetSubtextForSettings");
var Access;
(function (Access) {
    Access[Access["Email"] = 0] = "Email";
    Access[Access["Domain"] = 1] = "Domain";
    Access[Access["Password"] = 2] = "Password";
    Access[Access["Springboard"] = 3] = "Springboard";
})(Access || (Access = {}));
exports.AccessSettingsMenuSelector = (0, mobx_react_1.observer)(function (props) {
    return (react_1.default.createElement(ShareSettingsOptionSection_1.ShareSettingsOptionSection, { icon: react_1.default.createElement(icons_1.User, null), settingTitle: "Access settings", settingStatus: getSubtext(props), onClick: props.onClick, disabled: props.disabled }));
});
function getSubtext(props) {
    var enabledSettings = getEnabledSettings(props);
    return (0, GetSubtextForSettings_1.getSubtextForSettings)(enabledSettings, textForAccessSetting, "Anyone with the shareable link");
}
function getEnabledSettings(_a) {
    var identityMappingStore = _a.identityMappingStore, isPasswordProtected = _a.isPasswordProtected, hasPassword = _a.hasPassword, refreshedIdentityProtected = _a.refreshedIdentityProtected;
    var enabledSettings = [];
    if (identityMappingStore.isLimitDomainsEnabled) {
        enabledSettings.push(Access.Domain);
    }
    if (identityMappingStore.isEmailVerificationEnabled) {
        enabledSettings.push(Access.Email);
    }
    if (identityMappingStore.isEnabled && refreshedIdentityProtected) {
        enabledSettings.push(Access.Springboard);
    }
    if (isPasswordProtected && hasPassword) {
        enabledSettings.push(Access.Password);
    }
    return enabledSettings;
}
function textForAccessSetting(accessSetting, useAbbreviated) {
    switch (accessSetting) {
        case Access.Email:
            return useAbbreviated ? "Email Auth" : "Authenticate with Email";
        case Access.Domain:
            return "Domain security";
        case Access.Password:
            return useAbbreviated ? "Password" : "Password protected";
        case Access.Springboard:
            return useAbbreviated ? "Springboard Auth" : "Authenticate with Springboard";
    }
}
